import { ReactComponent as GivEnergyLogoSvg } from "assets/givenergy-logo.svg";
import clsx from "clsx";
import PropTypes from "prop-types";

function GivEnergyLogo({ className }) {
  return (
    <GivEnergyLogoSvg
      className={clsx(className, "text-black dark:text-white")}
    />
  );
}

GivEnergyLogo.propTypes = {
  className: PropTypes.string,
};

export default GivEnergyLogo;
